import { render, staticRenderFns } from "./Packing_out.vue?vue&type=template&id=0bc6af77&scoped=true"
import script from "./Packing_out.vue?vue&type=script&lang=js"
export * from "./Packing_out.vue?vue&type=script&lang=js"
import style0 from "./Packing_out.vue?vue&type=style&index=0&id=0bc6af77&prod&lang=css"
import style1 from "./Packing_out.vue?vue&type=style&index=1&id=0bc6af77&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc6af77",
  null
  
)

export default component.exports